<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('Recomendación')"
          :directory="$t('Evaluación/Testificación')"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          <button
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            @click="openDeleteModal"
          >
            Aceptar recomendaciones
          </button>
        </div>
      </div>
    </div>
    <div>
      <app-note
        class="mb-primary"
        :title="$t('note')"
        content-type="html"
        :notes="paginationInstruction"
      />
      <br />

      <app-table :id="tableId" :options="options" @action="getListAction" />
      <corrective-actions-modal
        v-if="isAddEditModalActive"
        :table-id="tableId"
        :selected-url="selectedUrl"
        @close-modal="closeAddEditModal"
        modalId="modal-add-edit"
      />

      <app-confirmation-modal
        v-if="deleteConfirmationModalActive"
        :preloader="deleteLoader"
        modal-id="modal-confirm-id"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="Confirmación"
        message="¿Desea procesar este registro?"
        firstButtonName="Aceptar"
        secondButtonName="Cancelar"
        modalClass="success"
        icon="cpu"
      />
    </div>
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../../apiUrl";
import { RecomendationTableHelpers } from "./RecomendationTableHelpers";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosPost } from "../../../../../../../../resources/js/app/helpers/AxiosHelper";

export default {
  extends: CoreLibrary,
  name: "corrective-actions-form",
  mixins: [FormMixin, RecomendationTableHelpers],
  props: {
    evaluationId: String,
  },

  data() {
    return {
      paginationInstruction: [
        this.$t(
          'Recuerde que para continuar el proceso todas las evaluaciones testificaciones registradas deben aparecer con estado <strong class="text-primary">FINALIZADO</strong>.'
        ),
      ],
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "pending-list",
      rowData: {},
      option: 0,
      list: [
        {
          id: "0",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
      options: {
        url: `${actions.EXECUTIVE_DIRECTOR_ACREDITATION}/show/${this.evaluationId}`,
        name: this.$t("demo_crud"),
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("Rechazar"),
            icon: "x",
            type: "none",
            component: "corrective-actions-modal",
            modalId: "corrective-add-edit-modal",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
  },
  methods: {
    returnPage() {
      window.location.href = `${actions.EXECUTIVE_DIRECTOR_ACREDITATION}`;
    },
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#corrective-add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },

    /**
     * $emit form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "Ver archivo") {
        window.open(this.rowData.final_report_commission.full_url, "_blank");
      } else if (actionObj.title == this.$t("Rechazar")) {
        var request = {};
        request["id"] = this.rowData.id;

        if (this.rowData.status == "46") {
          this.$toastr.s("Registro procesado con éxito");
          this.selectedUrl = `${actions.EXECUTIVE_DIRECTOR_ACREDITATION}/update`;
          axiosPost(this.selectedUrl, request).then((data) => {
            this.$toastr.s("Registro procesado con éxito");
            this.reSetData();
          });
        } else {
          this.$toastr.e(
            "No puede procesar esta evaluación, estado: <strong>En proceso</strong>"
          );
        }
      }
    },

    confirmed() {
      this.deleteLoader = true;
      const url = `${actions.EXECUTIVE_DIRECTOR_ACREDITATION}/store/${this.evaluationId}`;
      const data = {
        evaluationId: this.evaluationId,
      };
      axios
        .post(url, data)
        .then(({ data: res }) => {
          this.deleteLoader = false;
          $("#modal-confirm-id").modal("hide");
          this.cancelled();
          if (res.status === true) {
            // this.$toastr.s("Registro procesado con exito");
            this.returnPage();
          } else {
            this.$toastr.e(res.data);
          }
        })
        .catch(({ error }) => {});
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      window.location.href = `${actions.EXECUTIVE_DIRECTOR_ACREDITATION}/edit/${this.evaluationId}`;
    },
  },
};
</script>